import _ from 'underscore';

export const ResponsiveSearchAd = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Responsive Search Ad',
    },
    Headlines: {
      'bulk-upload-header': 'Headline',
      'bulk-upload-mapper': function (value) {
        return JSON.stringify(_.map(value, i => ({
          text: i.Asset.Text,
          ...(i.Asset.SourceType ? { sourceType: i.Asset.SourceType } : {}),
          pinnedField: i.PinnedField,
        })));
      },
    },
    Descriptions: {
      'bulk-upload-header': 'Description',
      'bulk-upload-mapper': function (value) {
        return JSON.stringify(_.map(value, i => ({
          text: i.Asset.Text,
          ...(i.Asset.SourceType ? { sourceType: i.Asset.SourceType } : {}),
          pinnedField: i.PinnedField,
        })));
      },
    },
    Path1: {
      'bulk-upload-header': 'Path 1',
    },
    Path2: {
      'bulk-upload-header': 'Path 2',
    },
    DisplayUrl: {
      'bulk-upload-header': 'Domain',
    },
    FinalUrls: {
      'bulk-upload-header': 'Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    MobileFinalUrls: {
      'bulk-upload-header': 'Mobile Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
    },
    FinalUrlSuffix: {
      'bulk-upload-header': 'Final Url Suffix',
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        return _.map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
      },
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
    NativePreference: {
      'bulk-upload-header': 'Ad Format Preference',
      'bulk-upload-mapper': function (value) {
        const mapping = {
          None: 'All',
          NativePreference: 'Native',
        };

        return mapping[value];
      },
    },
    PerformancePrediction: {
      'bulk-upload-header': 'Performance Prediction',
      'bulk-upload-mapper': function (value) {
        return value ? JSON.stringify(value) : '';
      },
    },
  },
};
